import { render, staticRenderFns } from "./u-dialog.vue?vue&type=template&id=17b9fc00&scoped=true&"
import script from "./u-dialog.vue?vue&type=script&lang=js&"
export * from "./u-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b9fc00",
  null
  
)

export default component.exports